const showDescriptions = {
  "Nocny Promil": "Audycja nocna, emitowana w nocy! Trochę wszystko i nic. Jeśli twoje życie nie ma sensu, to ta audycja z pewnością ci nie pomoże.",

  "Audycja Inaczej niż w radiu": "Cechą charakterystyczną tej audycji jest jej niepowtarzalny brak charakteru. Usłyszysz tu wszystko, czego algorytm Spotify ci nie zaproponuje.",
  
  "Inaczej niż w streamingu": "Cechą charakterystyczną tej audycji jest jej niepowtarzalny brak charakteru. Usłyszysz tu wszystko, czego algorytm Spotify ci nie zaproponuje.",

  "Kawa i Promile": "Lubię ten stan - papierosy, kawa, ja - Radio Promil edition.",

  "The 70's Show": "Czasy, gdy Watergate zdarzało się raz na dekadę, a nie raz na tydzień. Gdy w USA z głośników wybrzmiewało The Doors, a w Polsce mogłeś co najwyżej zostać ochlapanym wodą z kałuży przez Porsche Maryli Rodowicz.",

  "Audycja Latynoska": "Gorące rytmy latynoskie, cumbia, salsa i latino pop. Lo dice el DJ Gie, que siempre sabe lo que hay, bebé!",

  "Muzyka Sprzed Rock'n'Rolla": "Muzyka z czasów przed narodzinami rock'n'rolla - ale po wynalezieniu elektryczności i trwałej ondulacji!",

  "00's mix": "Nawet Twoja stara wie ocb, a jak nie wie to żal.pl. Najlepsze hity z lat 2000-2010 - subiektywnie obiektywne! Pop, rock, hip-hop i elektroniczna muzyka, która przypomni ci dźwięk zamykanych drzwi w Ikarusie.",

  "80's mix": "Thatcher, Reagan, Jaruzelski, Czarnobyl... pomimo licznych katastrof klimat tej dekady nadal inspiruje i pobudza.",

  "90's mix": "Wierzycie w reinkarnację? W latach 90. zmarł Kurt Cobain, a narodził się DJ Mati. Przypadek? Nie sądzę...",

  "Classic Rock": "Klasyki rocka wszech czasów, również w Polsce! Od Led Zeppelin po Bruce'a Springsteena - Born in the PRL.",

  "0,7 po 20": "W piątki i soboty zajmujemy się zaawansowaną matematyką, gdzie 1 + 1 = 0,7.",

  "Hip Hop Promil": "Najlepszy polski i zagraniczny hip-hop. My tu tworzymy ustrój, cały świat mamy u stóp!",

  "Jazzujemy z Promilem": "Nie mylić z jizzowaniem. Trochę kultury, chamie!",

  "Under the Covers": "Tylko oryginały znanych utworów. Dowiedz się, kogo okradł twój idol i jak autorski jest ten nowy hit.",

  "The Headbang Express": "Nie wal głową w mur i odpal The Headbang Express. Ciężki metal, twardy kamień.",

  "Rap Gie": "Audycja poświęcona rapowi, z akcentem na GIE. Odkryj nowy muzykę, tak jak GIE odkrywa G.",

  "Winamp Playlist": "Losowa playlista inspirowana Winampem. Nieprzewidywalna mieszanka gatunków i nastrojów, niczym opis twojego starego na Gadu-Gadu.",

  "Promillenials": "Muzyka dla pokolenia millenialsów! Przeboje z końca lat 90-tych, 2000-tych i tych z drugiej dekady, której słuchała każda maniura i przychlast. Poczuj się spox, nawet gdy nie stać cię na mieszkanie, bo jesz za dużo tostów z awokado.",

  "Promil OST": "Ścieżki dźwiękowe z filmów i seriali. Muzyka filmowa, która porusza emocje i opowiada historie bez słów.",

  "Girl Power Hour": "Godzina cierpienia każdego heteroseksualnego faceta. Kompetentne osoby przejmują antenę. SLAY QUEEN!",

  "Hangover Playlist": "Muzyka na kaca - Jedyna na świecie lista z hitami tak dobrymi, że zagłuszą twoje wyrzuty sumienia.",

  "W domach z betonu – dźwięki PRL": "Muzyka polska z czasów PRL-u. Od big-beatu po zespoły studenckie - socjalizm w poniedziałek nigdy nie brzmiał tak dobrze!",

  "Półtora Godziny Półtoraka": "Kompendium wiedzy o wszystkim, co jest absolutnie zbędne i nieistotne, a jednocześnie na wszystkich okładkach. Prowadzi jedyny, absolutnie przeciętny, Przemek Marcin Półtorak.",

  "Promil Nowej Fali": "Nowa fala rocka i alternatywy. Cofamy się do lat 80-tych, kiedy to powstały zespoły, które zdefiniowały brzmienie alternatywne na dekady i dziesięciolecia.",

  "Przez Promila Do Serca": "Bo krew wysycona etanolem z każdej żyły dociera do serca. A jeszcze skuteczniej do głowy. Bo żaden algorytm nie rozpala tak jak Promil.",

  "Wieczorne Warki": "Audycja prowadzona pod patronatem Państwowej Organizacji Psów Rasy Mieszanej KUNDELOZA. To, czego nie możesz wywarczeć w ciągu dnia, wyszczekaj z siebie wieczorem.",

  "Lato z Promilem": "Było ciepłe lato, choć czasem padało / Dużo wina się piło i mało się spało...",

  "Jugoton": "Muzyka jugosłowiańska z czasów minionych. Rock, pop i folk z bałkańskiego kręgu kulturowego. Tito nie przewraca się w grobie, on kręci się jak pieprzony wentylator.",

  "Jesień z Dupy Średniowiecza": "Jesień dotarła tam, gdzie Słońce nie zaglądało od średniowiecza. Niektóre rzeczy po prostu pasują do siebie, tak jak jesień i dupa średniowiecza.",

  "Fika z Promilem": "Nie kto, tylko co. Fika to coś, czego nie masz - przerwa na kawę i ciacho w odpowiednim towarzystwie. Playlista z muzyką skandynawską, której nie musisz sam składać."
};

export default showDescriptions;